import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { GlobalService } from '../service/global.service';
import { TokenService } from '../service/token.service';
import { ChannelTypeInfo } from '../model/ChannelType.model';
import { LookupInfo } from '../model/lookup.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-channel-type-management',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './channel-type-management.component.html',
  styleUrls: ['./channel-type-management.component.css']
})
export class ChannelTypeManagementComponent implements OnInit {
  form: FormGroup;
  ChannelTypeList: ChannelTypeInfo[] = [];
  isOnUpdate: boolean = false;
  baseurl: string;
  currentPageNumber: number = 0;
  totalPages: number = 0;
  totalItems: number = 0;
  environment: number = 20;
  selectedChannelTypes: number[] = [];
  indexNo: number = 0;
  selectedChannelTypeId: number = 0;
  selectedChannelTypeName: string = '';
  availablePermissions: any[] = [];
  selectedPermissions: number[] = [];

  constructor(
    private httpClient: HttpClient,
    private formBuilder: FormBuilder,
    private GlobalService: GlobalService,
    private TokenService: TokenService,
    private router: Router
  ) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {
    this.environment = environment.PageSize;
    this.form = this.formBuilder.group({
      ChannelTypeId: [0],
      //ChannelTypeCode: [null, Validators.required],
      ChannelTypeName: [null, Validators.required],
      ChannelTypeFlagDealer: [null, Validators.required],
      CreateBy: localStorage.getItem("EmpCode"),
    });

    this.Clearinput();
    this.LoadChannelTypes();
  }

  Clearinput() {
    this.form.patchValue({
      ChannelTypeId: 0,
      //ChannelTypeCode: null,
      ChannelTypeName: null,
      ChannelTypeFlagDealer: "N",
      CreateBy: localStorage.getItem("EmpCode"),
    });
  }

  async LoadChannelTypes(target = null) {
    if (target != null) {
      //this.LoadChannelTypesUpdatePagination(target);
      this.currentPageNumber = target.currentPageNumber;
      this.totalPages = target.totalPages;
    }

    await this.LoadChannelTypesList();
  }

  async LoadChannelTypesList() {
    const auth_token = await this.TokenService.RefreshToken();//
    if (!auth_token) {
      console.error('No valid token');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    try {
      const objectjson = {
        rowFetch: this.environment,
        rowOFFSet: ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * this.environment
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "Channel/GetChannelTypeList",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ChannelTypeList = response;
      this.totalItems = this.ChannelTypeList.length;

      if (this.ChannelTypeList.length <= 0) {
        this.currentPageNumber = 0;
      } else {
        if (this.currentPageNumber == 0) this.currentPageNumber = 1;
        this.totalItems = Number(this.ChannelTypeList[0].itemTotal);
      }

      // Calculate total pages
      this.totalPages = Math.ceil(this.totalItems / this.environment);
    } catch (error) {
      console.error('Error loading channel types:', error);
    }
  }

  async btnClick_onCreateChannelType() {
    this.isOnUpdate = false;
    this.Clearinput();
    $('#ModalChannelType').modal('show');
  }

  async btnClick_onSetPermissionChannelType(channelTypeId: number) {
    this.selectedChannelTypeId = channelTypeId;
    const channelType = this.ChannelTypeList.find(x => x.ChannelTypeId === channelTypeId);
    
    if (channelType) {
      this.selectedChannelTypeName = channelType.ChannelTypeName;
      
      // Load permissions for this channel type
      await this.loadChannelTypePermissions(channelTypeId);
      
      // Show the modal
      $('#ModalChannelTypePermission').modal('show');
    }
  }
  
  async loadChannelTypePermissions(channelTypeId: number) {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    try {
      // Get the channel type code from the channel type ID
      const channelType = this.ChannelTypeList.find(x => x.ChannelTypeId === channelTypeId);
      if (!channelType) {
        console.error('Channel type not found');
        return;
      }
      
      // Prepare the request payload
      const requestData = {
        ChannelTypeCode: channelType.ChannelTypeCode
      };
      
      // Call the API to get channel type permissions
      const response = await this.httpClient.post<any>(
        this.baseurl + "Channel/GetChannelTypePermission",
        JSON.stringify(requestData),
        httpOptions
      ).toPromise();
      
      if (response) {
        // Map the response to our UI model
        this.availablePermissions = response.map(role => ({
          id: role.RoleId,
          code: role.RoleCode,
          name: role.RoleName,
          isSelected: role.IsSelected === 'Y'
        }));
        
        // Extract selected permission IDs
        this.selectedPermissions = this.availablePermissions
          .filter(p => p.isSelected)
          .map(p => p.id);
      } else {
        this.availablePermissions = [];
        this.selectedPermissions = [];
      }
    } catch (error) {
      console.error('Error loading channel type permissions:', error);
      // Fallback to empty permissions if API fails
      this.availablePermissions = [];
      this.selectedPermissions = [];
    }
  }
  
  isPermissionSelected(permissionId: number): boolean {
    return this.selectedPermissions.includes(permissionId);
  }
  
  togglePermission(permissionId: number, isChecked: boolean) {
    if (isChecked && !this.selectedPermissions.includes(permissionId)) {
      this.selectedPermissions.push(permissionId);
    } else if (!isChecked && this.selectedPermissions.includes(permissionId)) {
      this.selectedPermissions = this.selectedPermissions.filter(id => id !== permissionId);
    }
  }
  
  async saveChannelTypePermissions() {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    try {
      // Get the channel type code from the channel type ID
      const channelType = this.ChannelTypeList.find(x => x.ChannelTypeId === this.selectedChannelTypeId);
      if (!channelType) {
        console.error('Channel type not found');
        return;
      }
      
      // Create an array of ChannelTypeRole objects for each selected permission
      const channelTypeRoles = this.selectedPermissions.map(permissionId => {
        const permission = this.availablePermissions.find(p => p.id === permissionId);
        return {
          ChannelTypeCode: channelType.ChannelTypeCode,
          RoleCode: permission.code,
          CreateBy: localStorage.getItem("EmpCode")
        };
      });
      
      // Create the request payload
      const data = {
        ChannelTypeCode: channelType.ChannelTypeCode,
        ChannelTypeRoles: channelTypeRoles,
        UpdateBy: localStorage.getItem("EmpCode")
      };
      
      // Since we don't have a specific endpoint for saving permissions yet,
      // we'll need to create one on the backend. For now, we'll use a placeholder
      // endpoint name that should be created on the backend.
      const response = await this.httpClient.post<any>(
        this.baseurl + "Channel/SaveChannelTypePermissions",
        JSON.stringify(data),
        httpOptions
      ).toPromise();

      console.log(response)

      if (response.success === true) {
        // Close the modal on success
        $('#ModalChannelTypePermission').modal('hide');
        
        // Optional: Show success message
        alert('Permissions saved successfully');
      }
    } catch (error) {
      console.error('Error saving channel type permissions:', error);
      alert('Error saving permissions. Please try again.');
    }
  }

  async btnClick_onUpdateChannelType(channelTypeId: number) {
    this.isOnUpdate = true;
    const channelType = this.ChannelTypeList.find(x => x.ChannelTypeId === channelTypeId);
    if (channelType) {
      this.form.patchValue({
        ChannelTypeId: channelType.ChannelTypeId,
        ChannelTypeCode: channelType.ChannelTypeCode,
        ChannelTypeName: channelType.ChannelTypeName,
        ChannelTypeFlagDealer: channelType.ChannelTypeFlagDealer
      });
    }
    $('#ModalChannelType').modal('show');
  }

  async btnSave() {
    if (this.form.invalid) {
      this.GlobalService.validateAllFormFields(this.form);
      return;
    }

    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    try {
      const formData = this.form.value;
      
      // Set CreateBy and UpdateBy based on operation type
      if (this.isOnUpdate) {
        formData.UpdateBy = localStorage.getItem("EmpCode");
      } else {
        formData.CreateBy = localStorage.getItem("EmpCode");
      }

      const response = await this.httpClient.post<any>(
        this.baseurl + "Channel/SaveChannelType",
        JSON.stringify(formData),
        httpOptions
      ).toPromise();

      if (response === true) {
        this.Clearinput();
        this.LoadChannelTypes();
        $('#ModalChannelType').modal('hide');
      }
    } catch (error) {
      console.error('Error saving channel type:', error);
    }
  }

  async btnClick_deleteChannelType(channelTypeId: number) {
    if (!confirm('Are you sure you want to delete this channel type?')) {
      return;
    }

    await this.deleteChannelType(channelTypeId);
  }

  async btnClick_onDeleteChannelTypeList() {
    if (this.selectedChannelTypes.length === 0) {
      alert('Please select at least one channel type to delete');
      return;
    }

    if (!confirm('Are you sure you want to delete the selected channel types?')) {
      return;
    }

    for (const id of this.selectedChannelTypes) {
      await this.deleteChannelType(id);
    }

    this.selectedChannelTypes = [];
  }

  async deleteChannelType(channelTypeId: number) {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    try {
      const response = await this.httpClient.delete<any>(
        this.baseurl + `Channel/DeleteChannelType/${channelTypeId}`,
        httpOptions
      ).toPromise();

      if (response.success) {
        this.LoadChannelTypes();
      }
    } catch (error) {
      console.error('Error deleting channel type:', error);
    }
  }

  onCheckboxChange(channelTypeId: number, checked: boolean) {
    if (checked) {
      this.selectedChannelTypes.push(channelTypeId);
    } else {
      const index = this.selectedChannelTypes.indexOf(channelTypeId);
      if (index > -1) {
        this.selectedChannelTypes.splice(index, 1);
      }
    }
  }

  chkallclick(event: any) {
    const checked = event.target.checked;
    this.selectedChannelTypes = checked ? 
      this.ChannelTypeList.map(x => x.ChannelTypeId) : 
      [];
  }

  private LoadChannelTypesUpdatePagination(target: number) {
    if (target > 0) {
      //this.currentPageNumber = target;
    }
    this.LoadChannelTypes();
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  async onChannelTypeClick(channelType: ChannelTypeInfo) {

    try {
      // Prepare navigation state
      const navigationState = {
        ChannelTypeId: channelType.ChannelTypeId,
        ChannelTypeCode: channelType.ChannelTypeCode,
        ChannelTypeName: channelType.ChannelTypeName,
        ChannelTypeFlagDealer: channelType.ChannelTypeFlagDealer
      };

      // Navigate to appropriate page
      if (channelType.ChannelTypeFlagDealer === 'Y') {
        // Navigate to Dealer Mapping
        this.router.navigate(['/dealer-mapping'], {
          state: navigationState
        });
      } else {
        // Navigate to Channel Mapping
        this.router.navigate(['/channel-mapping'], {
          state: navigationState
        });
      }
    } catch (error) {
      console.error('Error redirecting:', error);
    }
  }
}
